import React, { useRef } from 'react';

const BasicDetails = ({
    formData,
    handleInputChange,
    handleDobChange,
    validateDobOnBlur,
    handleMobileChange,
    validateMobileOnBlur,
    validateEmailOnBlur,
    handleAadhaarChange,
    validateAadhaarOnBlur,
    handlePanChange,
    validatePanOnBlur,
    errors,
    validatedFields,
    // City Auto-complete props
    cityWrapperRef,
    filteredCities,
    showCitySuggestions,
    handleCityChange,
    handleSelectCity,
    handleCityKeyDown,
    PREDEFINED_STATES,
    PREDEFINED_CITIES
}) => {
    return (
        <div className="form-section">
            <h3 className="section-heading">Basic Information</h3>
            <div className="row">

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Full Name <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="text"
                            name="full_name"
                            placeholder="Enter your full name"
                            value={formData.full_name}
                            onChange={handleInputChange}
                            className={`form-input${errors.full_name ? ' error' : ''}`}
                        />
                        {errors.full_name && <span className="error-message">{errors.full_name}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Mobile Number <span style={{ color: 'red' }}>*</span></label>
                        <div className="d-flex">
                            <select
                                disabled={true}
                                name="mobilecountrycode"
                                value={formData.mobilecountrycode}
                                onChange={handleInputChange}
                                className="form-input"
                                style={{ width: '80px', marginRight: '10px' }}
                            >
                                <option value="+91">+91</option>
                                <option value="+1">+1</option>
                                <option value="+44">+44</option>
                            </select>
                            <div className="input-with-validation flex-grow-1">
                                <input
                                    type="tel"
                                    name="mobile_phone"
                                    placeholder="Enter 10 digit number"
                                    value={formData.mobile_phone}
                                    onChange={handleMobileChange}
                                    onBlur={validateMobileOnBlur}
                                    className={`form-input${errors.mobile_phone ? ' error' : ''} ${validatedFields.mobile_phone ? ' validated' : ''}`}
                                    maxLength={10}
                                    inputMode="numeric"
                                    disabled={true}
                                />
                                {validatedFields.mobile_phone && <span className="validation-check">✓</span>}
                            </div>
                        </div>
                        {errors.mobile_phone && <span className="error-message">{errors.mobile_phone}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Gender</label>
                        <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleInputChange}
                            className={`form-input${errors.gender ? ' error' : ''}`}
                        >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                        </select>
                        {errors.gender && <span className="error-message">{errors.gender}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Email ID <span style={{ color: 'red' }}>*</span></label>
                        <div className="input-with-validation">
                            <input
                                type="email"
                                name="email"
                                placeholder="example@domain.com"
                                value={formData.email}
                                onChange={handleInputChange}
                                onBlur={validateEmailOnBlur}
                                className={`form-input${errors.email ? ' error' : ''} ${validatedFields.email ? ' validated' : ''}`}
                            />
                            {validatedFields.email && <span className="validation-check">✓</span>}
                        </div>
                        {errors.email && <span className="error-message">{errors.email}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Date of Birth</label>
                        <div className="input-with-validation position-relative">
                            <input
                                type="text"
                                name="dob"
                                placeholder="DD-MM-YYYY (e.g., 13-11-1994)"
                                value={formData.dob}
                                onChange={handleDobChange}
                                onBlur={validateDobOnBlur}
                                className={`form-input${errors.dob ? ' error' : ''} ${validatedFields.dob ? ' validated' : ''}`}
                                maxLength={10}
                                inputMode="numeric"
                            />

                            {/* Hidden date input for picker */}
                            <input
                                type="date"
                                style={{
                                    position: 'absolute',
                                    right: '35px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '24px',
                                    height: '24px',
                                    opacity: 0,
                                    zIndex: 10,
                                    cursor: 'pointer'
                                }}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val) {
                                        const [y, m, d] = val.split('-');
                                        const formatted = `${d}-${m}-${y}`;
                                        // Call the parent's handler with a synthetic event
                                        handleDobChange({ target: { value: formatted, name: 'dob' } });
                                        // You might want to trigger validation manually if needed, 
                                        // or let the user click away / blur. 
                                        // To be safe, we can reuse the same event for blur validation:
                                        // validateDobOnBlur({ target: { value: formatted } }); // This might be tricky if it expects formData
                                    }
                                }}
                            />

                            {/* Calendar Icon */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="#6B6B6B"
                                className="bi bi-calendar"
                                viewBox="0 0 16 16"
                                style={{
                                    position: 'absolute',
                                    right: '38px', // Positioned to the left of the checkmark if it exists
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    pointerEvents: 'none' // Let clicks pass to the hidden input
                                }}
                            >
                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                            </svg>

                            {validatedFields.dob && <span className="validation-check">✓</span>}
                        </div>
                        {errors.dob && <span className="error-message">{errors.dob}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Address Line 1</label>
                        <input
                            type="text"
                            name="address1"
                            placeholder="Address Line 1"
                            value={formData.address1}
                            onChange={handleInputChange}
                            className={`form-input${errors.address1 ? ' error' : ''}`}
                        />
                        {errors.address1 && <span className="error-message">{errors.address1}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Address Line 2</label>
                        <input
                            type="text"
                            name="address2"
                            placeholder="Address Line 2"
                            value={formData.address2}
                            onChange={handleInputChange}
                            className={`form-input${errors.address2 ? ' error' : ''}`}
                        />
                        {errors.address2 && <span className="error-message">{errors.address2}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">State</label>
                        <select
                            name="state"
                            value={formData.state}
                            onChange={handleInputChange}
                            className={`form-input${errors.state ? ' error' : ''}`}
                        >
                            <option value="">Select State</option>
                            {PREDEFINED_STATES && PREDEFINED_STATES.map((st) => (
                                <option key={st} value={st}>
                                    {st}
                                </option>
                            ))}
                        </select>
                        {errors.state && <span className="error-message">{errors.state}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group" ref={cityWrapperRef} style={{ position: 'relative' }}>
                        <label className="form-label">City</label>
                        <input
                            type="text"
                            name="city"
                            placeholder="Search City"
                            value={formData.city}
                            onChange={handleCityChange}
                            onKeyDown={handleCityKeyDown}
                            onFocus={(e) => {
                                // Trigger empty search to standard behavior if needed, or just handleCityChange logic
                                handleCityChange(e);
                            }}
                            className={`form-input${errors.city ? ' error' : ''}`}
                            autoComplete="off"
                        />
                        {showCitySuggestions && (
                            <ul className="list-group position-absolute w-100" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                                {filteredCities.length > 0 ? (
                                    filteredCities.map((city, index) => (
                                        <li
                                            key={index}
                                            className="list-group-item list-group-item-action"
                                            onClick={() => handleSelectCity(city)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {city}
                                        </li>
                                    ))
                                ) : (
                                    <li className="list-group-item text-muted">No cities found</li>
                                )}
                            </ul>
                        )}
                        {errors.city && <span className="error-message">{errors.city}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Pincode</label>
                        <input
                            type="text"
                            name="pincode"
                            placeholder="6 digit Pincode"
                            value={formData.pincode}
                            onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, '');
                                if (val.length <= 6) handleInputChange({ target: { name: 'pincode', value: val } });
                            }}
                            className={`form-input${errors.pincode ? ' error' : ''}`}
                            maxLength={6}
                        />
                        {errors.pincode && <span className="error-message">{errors.pincode}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">AADHAR</label>
                        <div className="input-with-validation">
                            <input
                                type="text"
                                name="aadhar_number"
                                placeholder="XXXX-XXXX-XXXX"
                                value={formData.aadhar_number.replace(/(\d{4})(?=\d)/g, '$1-')}
                                onChange={handleAadhaarChange}
                                onBlur={validateAadhaarOnBlur}
                                className={`form-input${errors.aadhar_number ? ' error' : ''} ${validatedFields.aadhar_number ? ' validated' : ''}`}
                                maxLength={14}
                                inputMode="numeric"
                            />
                            {validatedFields.aadhar_number && <span className="validation-check">✓</span>}
                        </div>
                        {errors.aadhar_number && <span className="error-message">{errors.aadhar_number}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">PAN</label>
                        <div className="input-with-validation">
                            <input
                                type="text"
                                name="pan_number"
                                placeholder="ABCDE1234F"
                                value={formData.pan_number}
                                onChange={handlePanChange}
                                onBlur={validatePanOnBlur}
                                className={`form-input${errors.pan_number ? ' error' : ''} ${validatedFields.pan_number ? ' validated' : ''}`}
                                maxLength={10}
                                style={{ textTransform: 'uppercase' }}
                            />
                            {validatedFields.pan_number && <span className="validation-check">✓</span>}
                        </div>
                        {errors.pan_number && <span className="error-message">{errors.pan_number}</span>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BasicDetails;
